import actionCreatorFactory from 'typescript-fsa'

const actionCreator = actionCreatorFactory('socket.io')

export const init = actionCreator('INIT_REQUESTED')
